import { Box, IconButton, Subheader, Widget } from '@revolut-internal/ui-kit'

import { Tooltip } from 'modules/Monitoring/components/Tooltip/Tooltip'
import { FCWithChildren } from 'modules/Monitoring/types'

type QueueHealthPolicyItemProps = {
  instance: string
  allowsDelete?: boolean
  isReadonly?: boolean
  onDelete: VoidFunction
}

export const QueueHealthPolicyItem: FCWithChildren<QueueHealthPolicyItemProps> = ({
  allowsDelete = true,
  instance,
  isReadonly = false,
  onDelete,
  children,
}) => {
  return (
    <Widget px="s-16" pb="s-16">
      <Subheader variant="nested">
        <Subheader.Title>Alert {instance}</Subheader.Title>
        {!isReadonly && (
          <Subheader.Side>
            <Tooltip
              message={`A policy should have at least one ${instance}`}
              disabled={allowsDelete}
              placement="left"
            >
              <Box>
                <IconButton
                  useIcon="Delete"
                  size={16}
                  color="grey-tone-20"
                  disabled={!allowsDelete}
                  onClick={onDelete}
                >
                  Delete {instance}
                </IconButton>
              </Box>
            </Tooltip>
          </Subheader.Side>
        )}
      </Subheader>

      {children}
    </Widget>
  )
}
